import FastClick from 'fastclick'

document.addEventListener(
  'DOMContentLoaded',
  () => {
    FastClick.attach(document.body)
  },
  false
)
